import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import successToast from "../../toast/successToast";
import errorToast from "../../toast/errorToast";
import FormTextField from "../../form/text";
import { FormDropDown } from "../../form/dropdown";
import { FormTextAreaField } from "../../form/text-area";
import { useEffect, useState } from "react";
import { FormLocationPickerField } from "../../map/map-selector";
import { api } from "../../../redux/apis/api";

const CustomerDeliveryAddressEditModal = ({
  isOpen = false,
  onClose = () => {},
  listFnc = () => {},
  selectID,
  customer_id,
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const naviagte = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  const initialValues = {
    id: selectID ?? "",
    customer_id: data?.customer_id ?? "",
    name: data?.name ?? "",
    location: {
      lat: data?.location?.lat ?? "",
      lng: data?.location?.lng ?? "",
    },
    address: data?.address ?? "",
    state_id: data?.state_id ?? "",
    city_id: data?.city_id ?? "",
    pincode: data?.pincode ?? "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/customer/delivery-address/edit`, values)
      .then((response) => {
        successToast(response.message);
        onClose();
        listFnc();
        console.log(response, "response");
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/customer/delivery-address/read`, {
        id: selectID,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectID && isOpen === true) {
      fetchData();
    }
  }, [selectID, isOpen]);

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
    fetchCityDropDownData();
  }, []);

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[50rem] w-full md:p-8 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values }) => (
                <Form>
                  <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                    <h2 className="text-xl font-semibold capitalize">
                      customer delivery address - Edit
                    </h2>
                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => onClose()}
                        type="button"
                        className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <section className="overflow-auto w-full h-[60vh]">
                    <section className="w-full max-w-[40rem]">
                      <div className="my-4">
                        <FormTextField
                          name={"name"}
                          label={"name"}
                          placeholder={`Enter name`}
                        />
                      </div>
                      <div className="my-4">
                        <FormTextAreaField
                          name={"address"}
                          label={"address"}
                          placeholder={`Enter address`}
                          rows={3}
                        />
                      </div>
                      <div className="my-4">
                        <FormDropDown
                          name="state_id"
                          label="state"
                          options={stateList}
                          value={stateList?.find(
                            (item) => item?.value === values?.state_id
                          )}
                        />
                      </div>
                      <div className="my-4">
                        <FormDropDown
                          name="city_id"
                          label="city"
                          options={citiesList}
                          value={citiesList?.find(
                            (item) => item?.value === values?.city_id
                          )}
                        />
                      </div>
                      <div className="my-4">
                        <FormTextField
                          name={"pincode"}
                          label={"pincode"}
                          placeholder={`Enter pincode`}
                        />
                      </div>

                      <div>
                        <FormLocationPickerField
                          name={"location"}
                          label={"location"}
                          value={values?.location}
                        />
                      </div>
                    </section>
                  </section>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerDeliveryAddressEditModal;
